import { UnifiedWithdrawFormTranslations } from "./unified-withdraw-form-pt-br";

export const UNIFIED_WITHDRAW_FORM_EN_US: UnifiedWithdrawFormTranslations = {
	drawerTitle: "Withdraw & Transfer",
	steps: {
		information: "Information",
		review: "Review",
	},
	totalBalance: "Total Balance",
	sendTo: "Send to",
	sendToPlaceholder: "Type or select an account",
	addNewAccount: "+ Add new account",
	addAccountDrawerTitle: "New account",
	saveAccount: "Save account",
	cancelAddAccount: "Cancel",
	defaultAccountBadge: "Default account",
	liquidValue: "Net Amount",
	liquidValuePlaceholder: "$ 0.00",
	reason: "Request reason",
	reasonPlaceholder: "Enter the withdrawal reason",
	goBack: "Back",
	goForward: "Continue",
	submit: "Request withdrawal",
	errorMessage: "We couldn't process your request. Please try again.",
	successMessage: "Your withdrawal request was submitted successfully!",
	splitBar: {
		available: "Available",
		anticipation: "Anticipation",
	},
	totalChipGross: "Total with fees",
	anticipationFee: "Anticipation fee",
	thirdPartyFee: "Third-party account fee",
	valueAboveTotal: "Requested amount greater than the total with fees ({{value}})",
	feeError: {
		message: "We couldn't fetch the anticipation fee. Please try again.",
		retry: "Retry",
	},
	review: {
		valuesReview: "Values Review",
		typeLabel: "Type",
		typeWithdraw: "Withdrawal",
		typeWithdrawAndAnticipation: "Withdrawal + Anticipation",
		statusLabel: "Status",
		statusPending: "Processing",
		requestedValue: "Requested amount",
		walletValue: "Wallet balance",
		anticipatedValue: "Anticipated amount",
		thirdPartyFeeLabel: "Third-party account fee",
		anticipationFeeLabel: "Anticipation fee",
		grossValue: "Gross value",
		netValueToAccount: "Net value",
		amountToReceive: "Amount to receive",
		attentionBannerTitle: "Attention",
		attentionBannerMessage:
			"Requests submitted after 10:30 a.m. (Brasília time) will only be processed the following day.",
		bankDataTitle: "Bank details",
		holderLabel: "Account holder",
		accountTypeLabel: "Account type",
		agencyLabel: "Agency",
		accountNumberLabel: "Account number",
		pixKeyLabel: "PIX key",
	},
	completion: {
		title: "All set!",
		description: "The requested amount is being processed by the Finance team.",
	},
	partialFailure: {
		modalTitle: "Request partially processed",
		modalDescription:
			"Part of your request was processed, but the other part couldn't be completed.",
		title: "Incomplete processing",
		message:
			"Part of the operation completed, but the other part failed. Check the statement and retry what's missing.",
		notification:
			"Request partially processed — check the statement and retry what's missing.",
	},
};
